import * as React from 'react'
import { makeStyles } from "@material-ui/core";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import SendOutNotificationForm from './notificationForm';
import { pushNotificationAction } from '../../containers/dashboard/action';


const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: theme.colors.White,
        width: "100%",
        minHeight: "calc(100vh - 175px)",
        padding: "45px 90px",
        marginLeft: "220px",
        maxWidth: "70%"
    },
    headerContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .title": {
            color: theme.colors.Violet,
            fontFamily: theme.fontFamily.MARKPROMEDIUM,
            fontSize: "24px",
        },
    },
    headerName: {
        fontSize: "13px",
        fontFamily: theme.fontFamily.MARKPROHEAVY,
        opacity: "0.3",
        color: theme.colors.Violet,
    },
    body: {
        backgroundColor: theme.colors.White,
        padding: "12px",
        boxShadow: " 20px 20px 60px #e6e6e6,-20px -20px 60px #ffffff",
    }
}))

export default function PushNotification() {
    const classes = useStyles()
    const [form, setForm] = React.useState({ title: "", body: "" })
    const dispatch = useDispatch()

    const dashboardReducer = useSelector(state => state.dashboardReducer)

    const pushNotificationActionMethod = React.useCallback((data) => {
        return dispatch(pushNotificationAction(data))
    }, [dispatch])

    const handleFormSubmit = (e) => {
        e.preventDefault();
        pushNotificationActionMethod(form)
        setForm({title: "", body: ""})
    }
    return (
        <div className={classes.root}>
            {dashboardReducer?.error?.length ? (
                <div className={"error-container"}>
                    {Array.isArray(dashboardReducer.error) &&
                        dashboardReducer.error.map((each, index) => (
                            <div key={index}>{each}</div>
                        ))}
                </div>
            ) : null}
            {dashboardReducer?.success?.length ? (
                <div className={"success-container"}>
                    {Array.isArray(dashboardReducer.success) &&
                        dashboardReducer.success.map((each, index) => (
                            <div key={index}>{each}</div>
                        ))}
                </div>
            ) : null}
            <div className={classes.body}>
                <div className={classes.headerContainer}>
                    <header className={"title"}>Push Notification</header>
                </div>
                <SendOutNotificationForm
                    form={form}
                    setForm={setForm}
                    handleSubmit={handleFormSubmit}
                />
            </div>
        </div>
    )
}